var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6267",
    "data-name": "Group 6267",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.474,
    height: 30.474,
    viewBox: "0 0 30.474 30.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2386",
    "data-name": "Rectangle 2386",
    width: 30.474,
    height: 30.474,
    fill: "#fcbf49"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6266",
    "data-name": "Group 6266",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16265",
    "data-name": "Path 16265",
    d: "M15.237,2.745c4.068,0,4.55.015,6.157.089a8.43,8.43,0,0,1,2.829.525A4.72,4.72,0,0,1,25.975,4.5a4.723,4.723,0,0,1,1.14,1.752A8.432,8.432,0,0,1,27.64,9.08c.073,1.607.089,2.089.089,6.157s-.016,4.55-.089,6.157a8.432,8.432,0,0,1-.525,2.829,5.046,5.046,0,0,1-2.892,2.892,8.431,8.431,0,0,1-2.829.525c-1.606.073-2.088.089-6.157.089s-4.551-.016-6.157-.089a8.431,8.431,0,0,1-2.829-.525A4.721,4.721,0,0,1,4.5,25.975a4.722,4.722,0,0,1-1.14-1.752,8.432,8.432,0,0,1-.525-2.829c-.073-1.607-.089-2.089-.089-6.157s.015-4.55.089-6.157a8.433,8.433,0,0,1,.525-2.829A4.721,4.721,0,0,1,4.5,4.5a4.72,4.72,0,0,1,1.752-1.14A8.431,8.431,0,0,1,9.08,2.834c1.607-.073,2.089-.089,6.157-.089m0-2.745C11.1,0,10.58.018,8.955.092A11.183,11.183,0,0,0,5.256.8a7.47,7.47,0,0,0-2.7,1.757A7.469,7.469,0,0,0,.8,5.256a11.183,11.183,0,0,0-.708,3.7C.017,10.58,0,11.1,0,15.237s.017,4.657.092,6.282a11.183,11.183,0,0,0,.708,3.7,7.469,7.469,0,0,0,1.757,2.7,7.47,7.47,0,0,0,2.7,1.757,11.187,11.187,0,0,0,3.7.708c1.625.074,2.144.092,6.282.092s4.657-.018,6.282-.092a11.187,11.187,0,0,0,3.7-.708,7.791,7.791,0,0,0,4.456-4.456,11.181,11.181,0,0,0,.708-3.7c.074-1.625.092-2.144.092-6.282s-.018-4.657-.092-6.282a11.181,11.181,0,0,0-.708-3.7,7.469,7.469,0,0,0-1.757-2.7A7.47,7.47,0,0,0,25.218.8a11.183,11.183,0,0,0-3.7-.708C19.894.018,19.375,0,15.237,0",
    transform: "translate(0 0)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16266",
    "data-name": "Path 16266",
    d: "M111.684,103.861a7.824,7.824,0,1,0,7.824,7.824,7.824,7.824,0,0,0-7.824-7.824m0,12.9a5.079,5.079,0,1,1,5.079-5.079,5.079,5.079,0,0,1-5.079,5.079",
    transform: "translate(-96.448 -96.448)",
    fill: "#fcbf49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16267",
    "data-name": "Path 16267",
    d: "M305.491,75.739a1.828,1.828,0,1,1-1.828-1.828,1.828,1.828,0,0,1,1.828,1.828",
    transform: "translate(-280.292 -68.636)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.c0206f2cb36ad99cb6ccbb53c3af356f.svg";
export { ForwardRef as ReactComponent };